module.exports = function(bootstrap) {
	/*bootstrap.service("aemContent", ["$http", "$timeout", "$q", "$window","session", function($http, $timeout, $q, $window,session) {
		this.get = function(page, contentId) {
			return $http({
				url: page + "/jcr:content/" + contentId + ".json"
			});
		};
	}]);*/

	bootstrap.service("aemContent", ["services", "$timeout", "$q", "$window","$http","$location", function(services, $timeout, $q, $window,$http,$location) {
		this.queueDelay = 200; // delay in MS to wait for the queue to populate before sending a service request
		this.queue = {};
		this.typeCache = {};
		this.typeCacheBranded = {};
		this.qualifiers = {};
		// blockers is a special object, if it contains any keys, teamsite queue will pause and continue to collect ids
		// when blockers is once again empty (all added keys deleted), the teamsite queue will return to normal operation
		this.blockers = {};
		this.cache = {};

		this.getAll = function(contentType) {
			if (!this.typeCache[contentType]) {
				this.typeCache[contentType] = {deferred: $q.defer()};
				/*var self=this;
				this.getAEMJsonContent().then(function(aemJsonResponse){
					var content = {};
					for(var contentId in aemJsonResponse){
						var aemContentObj = aemJsonResponse[contentId];
						if(aemContentObj.hasOwnProperty("contentType") && contentType===aemContentObj.contentType){
							var contentValue = self.getQualifiedContent(aemContentObj,this.qualifiers);
							if(contentValue){
								content[contentId] = contentValue;
							}
						}
					}
				});*/

				/*services.rbsmbl.contentInfo().getAll(contentType, this.qualifiers).then((function(response) {
				 var content = {};
				 for (var i = 0; i < response.data.payload.contentResponse.length; i++) {
				 content[response.data.payload.contentResponse[i].name] = response.data.payload.contentResponse[i].value;
				 }
				 if (this.typeCache[contentType]) {
				 this.typeCache[contentType].deferred.resolve(content);
				 }
				 }).bind(this));*/
				var self=this;
				this.getAEMJsonContent().then(function(aemJsonResponse){
					var content = {};
					for(var contentId in aemJsonResponse){
						var aemContentObj = aemJsonResponse[contentId];
						if(aemContentObj.hasOwnProperty("contentType") && contentType===aemContentObj.contentType){
							var contentValue = self.getQualifiedContent(aemContentObj,this.qualifiers);
							if(contentValue){
								content[contentId] = contentValue;
							}
						}
					}
					if (self.typeCache[contentType]) {
						self.typeCache[contentType].deferred.resolve(content);
					}
				});


			}
			return this.typeCache[contentType].deferred.promise;
		};

		/*this.getAllBranded = function(contentType) {
			if (!this.typeCacheBranded[contentType]) {
				this.typeCacheBranded[contentType] = {deferred: $q.defer()};

				services.rbsmbl.contentInfo().getAllBranded(contentType, this.qualifiers).then((function(response) {
					var content = {};
					for (var i = 0; i < response.data.payload.contentResponse.length; i++) {
						content[response.data.payload.contentResponse[i].name] = response.data.payload.contentResponse[i].value;
					}
					if (this.typeCacheBranded[contentType]) {
						this.typeCacheBranded[contentType].deferred.resolve(content);
					}
				}).bind(this));
			}
			return this.typeCacheBranded[contentType].deferred.promise;
		};*/
		this.getAllBranded = function(contentType) {
			if (!this.typeCacheBranded[contentType]) {
				this.typeCacheBranded[contentType] = {deferred: $q.defer()};

				var self=this;
				this.getAEMJsonContent().then(function(aemJsonResponse){
					var content = {};
					for(var contentId in aemJsonResponse){
						var aemContentObj = aemJsonResponse[contentId];
						if(aemContentObj.hasOwnProperty("contentType") && contentType===aemContentObj.contentType){
							var contentValue = self.getQualifiedContent(aemContentObj,this.qualifiers);
							if(contentValue){
								content[contentId] = contentValue;
							}
						}
					}
					if (self.typeCacheBranded[contentType]) {
						self.typeCacheBranded[contentType].deferred.resolve(content);
					}
				});

				/*services.rbsmbl.contentInfo().getAllBranded(contentType, this.qualifiers).then((function(response) {
					var content = {};
					for (var i = 0; i < response.data.payload.contentResponse.length; i++) {
						content[response.data.payload.contentResponse[i].name] = response.data.payload.contentResponse[i].value;
					}
					if (this.typeCacheBranded[contentType]) {
						this.typeCacheBranded[contentType].deferred.resolve(content);
					}
				}).bind(this));*/
			}
			return this.typeCacheBranded[contentType].deferred.promise;
		};
		this.get = function(id) {
			if (this.cache[id]) {
				return this.cache[id];
			}
			if (!this.queue[id]) {
				this.queue[id] = {deferred: $q.defer()};
				this.processQueue();
			}
			return this.queue[id].deferred.promise;
		};
		this.getContent= function(listOfIds) {
			var deferred = $q.defer();
			var contentArray=[];


				var self=this;
				this.getAEMJsonContent().then(function(aemJsonResponse){

					for(var contentId in listOfIds){
						var aemContentObj = aemJsonResponse[contentId];

						var contentValue = aemContentObj?self.getQualifiedContent(aemContentObj,this.qualifiers):undefined;
						if(contentValue){
							var content = {name:"",value:""};
							content.value = contentValue;
							content.name = contentId;
							contentArray.push(content);
						}
					}
					deferred.resolve(contentArray);

				});

			return deferred.promise;
		};



		this.removeBlocker = function(name) {
			delete this.blockers[name];
		};
		this.addBlocker = function(name) {
			this.blockers[name] = true;
		};
		this.setQualifier = function(name, value) {
			this.qualifiers[name] = value;
		};

		this.getContentValue = function(aemContent){
			return aemContent && aemContent.text || undefined;
		};
		this.getAEMJsonContent = function(){
			var contentUrl = $location.$$absUrl.replace($location.$$url,"")+"/legacy-content.-1.json";
			var deferred = $q.defer();
			$http.get(contentUrl,{cache:true}).then(function(response){
				deferred.resolve(response.data);
			});
			return deferred.promise;
		};

		this.getQualifiedContent=function(aemContentObj){
			var qualifierObj = aemContentObj.qualifierContentValueDetails;
			var isQualified = true;
			var qualifierContent='';
			var qualifierId = '';
			var qualifierValue = '';

			console.log(aemContentObj);
			if (typeof aemContentObj == "string") {
				return this.getAEMJsonContent(aemContentObj).then((function(response) {
					if (response[aemContentObj]) {
						return this.getQualifiedContent(response[aemContentObj]);
					}
					else {
						return "{}";
					}
				}).bind(this));
			}

			if(qualifierObj){
				for(var qualifier in qualifierObj){
					if(qualifier.indexOf("jcr:")==-1 &&  qualifier.indexOf("_proto_")==-1){
						if(qualifier.indexOf("-")>-1){
							qualifierId = qualifier.substring(0,qualifier.indexOf('-'));
							qualifierValue = qualifier.substring(qualifier.indexOf('-')+1);
						}else{
							qualifierId = qualifier;
						}
					}
					// console.log(aemContentObj, qualifierId, qualifierValue);
					if (this.qualifiers[qualifierId] && (this.qualifiers[qualifierId] == qualifierValue || (parseInt(this.qualifiers[qualifierId]) && parseInt(qualifierValue) && parseInt(this.qualifiers[qualifierId]) == parseInt(qualifierValue)))) {
						isQualified = true;
						qualifierContent = qualifierObj[qualifier].text;
					}else{
						isQualified = false;
					}
				}
				if(qualifierContent){
					return qualifierContent;
				}
			}else{
				return aemContentObj.text;
			}


		};
		this.processQueue = function() {
			if (this.processQueueTimeout) {
				$timeout.cancel(this.processQueueTimeout);
			}
			this.processQueueTimeout = $timeout((function() {
				var blocked = false;
				for (var x in this.blockers) {
					blocked = true;
				}
				if (blocked) {
					this.processQueue();
				}
				else {
					var currentQueue = this.queue;
					// TODO: uncomment the below line to allow missing ID's to initiate multiple requests
					// not positive if we want this on or not yet.  Leaving off for now to show that cache is working
					// this.queue = {};

					var contentItems =this.getAEMJsonContent();


					var self=this;

					contentItems.then(function(response){
						if(response ){
							for (var contentId in currentQueue) {
								var aemContentObj=response[contentId];

								if(aemContentObj){
									var contentVal = self.getContentValue(aemContentObj);
									if (contentVal && currentQueue[contentId]) {
										currentQueue[contentId].deferred.resolve(contentVal);
									}
									delete self.queue[contentId];
									// Assign value to the cache, if value exists, use that value instead of the later value.
									// This is due to a teamsite bug in which multiple values for the same key are returned, in that situation we want the 1st returned value, not the last.
									self.cache[contentId] = self.cache[contentId] || $q.when(contentVal);
								}

							}


							var isQualified =true;
/*							for(var i=0;i<contentItems.length;i++){
								var contentItem = contentItems[i];
								if(contentItem.hasOwnProperty("qualifiers")){
									if(this.qualifiers ) {
										var contentQualifiers = contentItem.qualifiers;
										if (contentQualifiers.length > 0) {
											for (var j = 0; j < contentQualifiers.length; j++) {
												var qualifierName = contentQualifiers[j].name;
												var qualifierValue = contentQualifiers[j].value;

												if (this.qualifiers[qualifierName] && angular.equals(this.qualifiers[qualifierName],qualifierValue)) {

												} else {
													isQualified=false;
													break;
												}

											}
										}
									}else{
										isQualified=false;
										break;
									}
								}
								if(isQualified){
									if (currentQueue[content.name]) {
										currentQueue[content.name].deferred.resolve(content.value);
									}
								}
								delete this.queue[content.name];
							}*/

						}
					});

					//}








				}
			}).bind(this), this.queueDelay);
		};

		this.options = {devMode: false};
	}]);
	bootstrap.directive("aemContent", ["aemContent", "smoothFocus", function(aemContent, smoothFocus) {
		return {
			priority: 1001,	// Priority higher than ng-repeat.  This allows teamsite direcdtive to be placed on the same element as ng-repeat, and using
							   // the "teamsiteId as myVar" syntax, combined with ng-repeat "something in myVar", you can repeat over JSON data retrieved from teamsite
			scope: true,	// Create new scope, but not isolate.  This is usefull for the "teamsiteId as myVar" syntax
			link: function($scope, element, attrs, controller, transclude) {
				$scope.aemContent = attrs.aemContent;
				var match = /^\s*([\s\S]+?)\s+as\s+([\s\S]+?)\s*$/.exec($scope.aemContent);
				var aemContentId = $scope.aemContent;
				var lhs, rhs;
				if (match) {
					aemContentId = match[1];
					rhs = match[2];
				}
				$scope.options = aemContent.options;
				$scope.$watch('options.devMode', function() {
					aemContent.get(aemContentId).then(function(content) {
						if (match) {
							try {
								$scope[rhs] = JSON.parse(content);
							}
							catch (e) {
								$scope[rhs] = content;
							}
						}
						else {
							if ($scope.options.devMode) {
								element.html(aemContentId);
							}
							else {
								element.html(content);
							}
						}
						// Adjust focus incase teamsite content caused things on the page to be pushed around
						setTimeout(function() {
							smoothFocus.setTab();
						}, 500);
					});
				});
			}
		};
	}]);
}

